// extracted by mini-css-extract-plugin
export default {"container":"SideSection_container__MRsJd"};